import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import PaymentsRepository from '../../../repositories/PaymentsRepository';
import PaymentsDataRepository from '../../../../data/repositories/PaymentsDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_PENDING_PAYMENTS_REQUEST });
    XCheckpointManager.registerStart('Pago Online Ver cuotas');
    const paymentsRepository: PaymentsRepository = new PaymentsDataRepository();
    const pendingPaymentsResponse = yield call(
      paymentsRepository.getPendingPayments
    );
    XCheckpointManager.registerEnd('Pago Online Ver cuotas');

    if (!pendingPaymentsResponse) throw new Error('response null');

    if (pendingPaymentsResponse.errors) {
      yield put({
        type: Types.GET_PENDING_PAYMENTS_FAILURE,
        error: pendingPaymentsResponse.errors[0]?.message || 'Error desconocido'
      });
      return;
    }

    const nameMappings: Record<string, string> = {
      'Retiro de asignatura': 'Retiro de Curso'
    };

    const updatedPendingPaymentsResponse = {
      ...pendingPaymentsResponse,
      data: {
        ...pendingPaymentsResponse?.data,
        pendingPayments: {
          ...pendingPaymentsResponse?.data?.pendingPayments,
          items:
            pendingPaymentsResponse?.data?.pendingPayments?.items?.map(
              (payment: any) => {
                const name = payment?.name ?? '';
                return {
                  ...payment,
                  name: nameMappings[name] ?? name
                };
              }
            ) ?? []
        }
      }
    };

    yield put({
      type: Types.GET_PENDING_PAYMENTS_SUCCESS,
      data: updatedPendingPaymentsResponse?.data
    });
  } catch (error) {
    yield put({
      type: Types.GET_PENDING_PAYMENTS_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos.'
    });
  }
}
